import { useMemo } from 'react';

import InsightsApiExport from 'components/insights/layout/InsightsApiExport';
import { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getNetworkPerformanceAnalyticsFilters, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: InsightsQueryParams;
  extraFilters?: Record<string, unknown>;
};

export default function NetworkPerformanceApiExport({ extraFilters, ...props }: Props) {
  const storeFilters = useNetworkPerformanceStore((state) => getNetworkPerformanceAnalyticsFilters(state));

  const analyticsFilters = useMemo(
    () => (storeFilters && extraFilters ? { ...storeFilters, ...extraFilters } : storeFilters),
    [storeFilters, extraFilters]
  );

  return <InsightsApiExport {...props} analyticsFilters={analyticsFilters} />;
}
